<template>
  <div class="increase-product">
    <el-dialog title="创建跟卖信息" width="1200px" :visible.sync="dialogVisible" @close="closeDialog" top="4vh">
      <el-row type="flex">
        <upload-excel-component :on-success="handleSuccess" />
        <el-button type="primary" size="mini" style="margin-left: 10px;" @click="increaseInfo">增加一条</el-button>
        <el-button size="mini" @click="downloadTemplate">下载模板</el-button>
      </el-row>
      <div class="tips-box">注意事项：SKU不能重复，否则跟卖失败</div>
      <el-table :data="listTable" border>
        <el-table-column prop="asin" label="ASIN" align="center"></el-table-column>
        <el-table-column prop="sku" label="SKU" align="center"></el-table-column>
        <el-table-column prop="price" label="价格" align="center"></el-table-column>
        <el-table-column prop="maxPrice" label="最大价格" align="center"></el-table-column>
        <el-table-column prop="minPrice" label="最小价格" align="center"></el-table-column>
        <el-table-column prop="stock" label="库存" align="center"></el-table-column>
        <el-table-column prop="sourceLink" label="来源链接" align="center"></el-table-column>
        <el-table-column prop="priceRules" label="调价规则" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
              <el-button type="text" @click="deleteTableItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button type="primary" @click="submitIncrease" :loading="loadingSubmit">提 交</el-button>
      </div>

      <el-dialog title="创建跟卖信息" width="600px" :visible.sync="dialogInnerVisible" top="4vh" append-to-body>
        <el-form label-width="100px" ref="dialogInnerForm" :model="dialogInnerForm" :rules="dialogInnerFormRules">
          <el-form-item label="ASIN" prop="asin">
            <el-input v-model="dialogInnerForm.asin"></el-input>
          </el-form-item>
          <el-form-item label="SKU" prop="sku">
            <el-input v-model="dialogInnerForm.sku"></el-input>
          </el-form-item>
          <el-form-item label="价格" prop="price">
            <el-input v-model="dialogInnerForm.price"></el-input>
          </el-form-item>
          <el-form-item label="最大价格" prop="maxPrice">
            <el-input v-model="dialogInnerForm.maxPrice"></el-input>
          </el-form-item>
          <el-form-item label="最小价格" prop="minPrice">
            <el-input v-model="dialogInnerForm.minPrice"></el-input>
          </el-form-item>
          <el-form-item label="库存" prop="stock">
            <el-input v-model="dialogInnerForm.stock"></el-input>
          </el-form-item>
          <el-form-item label="来源链接" prop="sourceLink">
           <el-input v-model="dialogInnerForm.sourceLink"></el-input>
          </el-form-item>
          <el-form-item label="调价规则" prop="priceRules">
            <el-input v-model="dialogInnerForm.priceRules"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button type="primary" @click="addIncrease">提 交</el-button>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import UploadExcelComponent from '@/components/UploadExcel/index.vue'

export default {
  name: 'IncreaseProduct',
  components: {
    UploadExcelComponent
  },
  data() {
    return {
      dialogVisible: false,
      listTable: [],
      dialogInnerVisible: false,
      dialogInnerForm: {},
      dialogInnerFormRules: {
        asin: [{ required: true, message: '请输入ASIN码', trigger: 'blur'}],
        sku: [{ required: true, message: '请输入SKU码', trigger: 'blur'}],
        price: [{ required: true, message: '请输入价格', trigger: 'blur'}],
        maxPrice: [{ required: true, message: '请输入最大价格', trigger: 'blur'}],
        minPrice: [{ required: true, message: '请输入最小价格', trigger: 'blur'}],
        stock: [{ required: true, message: '请输入库存', trigger: 'blur'}],
        sourceLink: [{ required: true, message: '请输入来源链接', trigger: 'blur'}],
        // priceRules: [{ required: true, message: '请输入调价规则', trigger: 'blur'}],
      },
      loadingSubmit: false
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.listTable = []
      this.loadingSubmit = false
      this.dialogVisible = false
    },
    increaseInfo() {
      this.dialogInnerVisible = true
      const timeStamp = new Date().getTime()
      this.dialogInnerForm = {
        id:`${this.listTable.length + 1}${timeStamp}`,
        asin: '',
        sku: '',
        price: '',
        maxPrice: '',
        minPrice: '',
        stock: '',
        sourceLink: '',
        priceRules: '',
      }
    },
    addIncrease() {
      this.$refs.dialogInnerForm.validate((valid) => {
        if (!valid) return
        const tempObj = JSON.parse(JSON.stringify(this.dialogInnerForm))
        this.listTable.push(tempObj)
        this.dialogInnerVisible = false
      })
    },
    deleteTableItem(row) {
      const itemIndex = this.listTable.findIndex(item => item.id === row.id)
      this.listTable.splice(itemIndex, 1)
    },
    handleSuccess({ results }) {
      const result = results.every(item => {
        if (!item.ASIN) return false
        if (!item.SKU) return false
        if (!item['价格']) return false
        if (!item['最小价格']) return false
        if (!item['最大价格']) return false
        if (!item['库存']) return false
        if (!item['来源链接']) return false
        return true
      })
      if (!result) {
        this.$message.warning('请将数据填写完整')
        return
      }
      this.listTable = results.map((item, index) => {
        const timeStamp = new Date().getTime()
        return {
          id: `${index}${timeStamp}`,
          asin: item.ASIN,
          sku: item.SKU,
          price: Number(item['价格']).toFixed(2),
          maxPrice: Number(item['最大价格']).toFixed(2),
          minPrice: Number(item['最小价格']).toFixed(2),
          stock: Number(item['库存']).toFixed(),
          sourceLink: item['来源链接'],
          priceRules: item['调价规则']
        }
      })
    },
    submitIncrease() {
      this.loadingSubmit = true
      this.listTable.forEach(item => {
        delete item.id
      })
      this.$emit('confirm', this.listTable)
    },
    downloadTemplate() {
      const aEle = document.createElement('a')
      aEle.href = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E4%B8%8A%E4%BC%A0%E8%B7%9F%E5%8D%96.xlsx'
      aEle.click()
      this.$message.success('正在下载...')
    }
  }
}
</script>

<style lang="scss" scoped>
.increase-product {
  .tips-box {
    color: red;
    margin: 10px 0;
  }
}
</style>
